document.addEventListener("DOMContentLoaded", () => {
    const drawerSelectors = [
        'details.menu-drawer-container', 
        'details#Details-Facets.open-facets-btn',
        'details#Details-shop-the-look'
    ]

    const inputSelectors = [
        'input#ExpandStickyCart'
    ]

    if(window.innerWidth > 749) return

    const config = { attributes: true }
    const callback = (mutationList, observer) => {
        for(mutation of mutationList) {
            console.log(mutation)
            if(mutation.type === "attributes") {
                if(mutation.target.hasAttribute('open')) document.body.style.overflow = 'hidden'
                else document.body.style.overflow = 'auto'
            }
        }
    }

    drawerSelectors.forEach(selector => {
        let element = document.querySelector(selector)
        if(!!!element) return

        const observer = new MutationObserver(callback)
        observer.observe(element, config)
    })

    inputSelectors.forEach(selector => {
        let element = document.querySelector(selector)
        if(!!!element) return

        element.addEventListener('input', (event) => {
            if(event.target.checked) document.body.style.overflow = 'hidden'
            else document.body.style.overflow = 'auto'
        })
    })
})